import { getQueryParams } from '../../utils/query-params';
import { isBrowser } from '../../utils/is-browser';

export const formatDonationContent = (content) => {
  const single = [];
  const monthly = [];

  for (let i = 0; i < 4; i += 1) {
    const singleAmount = content[`singleAmount${i + 1}`];
    const singleDescription = content[`singleDescription${i + 1}`];
    if (singleAmount !== null) {
      single[i] = {
        amount: singleAmount,
        description: singleDescription,
      };
    }
  }

  for (let i = 0; i < 4; i += 1) {
    const monthlyAmount = content[`monthlyAmount${i + 1}`];
    const monthlyDescription = content[`monthlyDescription${i + 1}`];
    if (monthlyAmount != null) {
      monthly[i] = {
        amount: monthlyAmount,
        description: monthlyDescription,
      };
    }
  }

  return {
    single,
    monthly,
  };
};

export const getDonationFrequency = (defaultDonationFrequency) => {
  if (!isBrowser) {
    return defaultDonationFrequency || 'single';
  }

  const { frequency } = getQueryParams(window.location.search);

  switch (frequency) {
    case 'once':
    case 'single':
      return 'single';
    case 'monthly':
    case 'regular':
      return 'monthly';
    default:
      return defaultDonationFrequency || 'single';
  }
};

export const getDonationAmount = () => {
  if (!isBrowser) {
    return null;
  }

  const { amount } = getQueryParams(window.location.search);
  if (amount !== undefined || !Number.isNaN(parseInt(amount))) {
    return parseInt(amount);
  }
};

// default frequency values from Contentful are different to values expected in form
export const convertFrequencies = (frequency) => {
  if (frequency === 'single') return 'once';
  if (frequency === 'monthly') return 'regular';
};
